module.exports = "/images/visa-icon.png";